import axios from 'axios';
import { IMPROVE_CONFIG } from '@/config.js';

export default {
  contactUs: function(user) {
    return axios.post(IMPROVE_CONFIG.API_URL + '/contact-us', {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      company_name: user.company_name,
      messages: user.messages,
      newsletter: user.newsletter,
      // Honeypot: real users never fill this; forwarded so the API can drop bots.
      company_website: user.company_website,
    });
  },
  register: function(user) {
    return axios.post(IMPROVE_CONFIG.API_URL + '/register', {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      company_name: user.company_name,
      phone: user.phone,
      password: user.password,
      confirm_password: user.confirm_password,
      newsletter: user.newsletter,
      banding: user.banding,
      refid: user.refid,
    });
  },
};
